// extracted by mini-css-extract-plugin
export default {"text":"text_nC09G","list":"list__YL55"};